import type { GetServerSideProps, InferGetServerSidePropsType } from 'next'
import { StorefrontPage, resolveStorefrontRouteOutcome } from '../catch-all-page/page-entry'
import { resolveRequestedPathname } from '../catch-all-page/locale'
import type { CatchAllPageProps } from '../catch-all-page/types'

export const getServerSideProps: GetServerSideProps<CatchAllPageProps> = async (ctx) =>
  resolveStorefrontRouteOutcome({
    ctx,
    requestedPathname: resolveRequestedPathname(ctx.params?.slug),
  })

export default function CatchAllPage(
  props: InferGetServerSidePropsType<typeof getServerSideProps>,
) {
  return <StorefrontPage {...props} />
}
